import { render, staticRenderFns } from "./ResetPasswordUpdate.vue?vue&type=template&id=32b4344c&scoped=true"
import script from "./ResetPasswordUpdate.vue?vue&type=script&lang=js"
export * from "./ResetPasswordUpdate.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordUpdate.vue?vue&type=style&index=0&id=32b4344c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b4344c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32b4344c')) {
      api.createRecord('32b4344c', component.options)
    } else {
      api.reload('32b4344c', component.options)
    }
    module.hot.accept("./ResetPasswordUpdate.vue?vue&type=template&id=32b4344c&scoped=true", function () {
      api.rerender('32b4344c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/authentication/ResetPasswordUpdate.vue"
export default component.exports